import {
  FormChecklistTemplate,
  useFormChecklistTemplateQuery,
} from 'graphql-common';

type Args = {
  id: string;
};

export default function useFormChecklistTemplateQueryHook(args: Args) {
  const { id } = args;

  const query = useFormChecklistTemplateQuery({
    fetchPolicy: 'network-only',
    skip: !id,
    variables: { id },
  });

  const { refetch, error, loading, data: queryData, previousData } = query;
  const data = queryData || previousData;
  const firstLoading = loading && queryData === undefined;
  const formChecklistTemplate = data?.data as FormChecklistTemplate;

  return {
    data: formChecklistTemplate,
    loading,
    error,
    refetch,
    firstLoading,
  };
}
